export const STORAGE_KEY = "served_cookie_consent";

export function hasCookieConsent() {
  try {
    return Boolean(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}
